import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"],
  _excluded2 = ["data"];
import { registerQuery, useQuery } from 'data-fetching-client';
import { useHasGate } from '../../auth/hooks/authHooks';
import { knowledgeBaseMigrationReportSync, refetchCache } from '../../migration-handler/singleton/migrationHandler';
import KnowledgeBaseApi from '../api/KnowledgeBaseApi';
import { convertSCPToLegacyKnowledgeBase } from '../data/KnowledgeBase';
import { GATES } from '../../utils/gatesUtils';
import http from 'hub-http/clients/apiClient';
import { TEMPLATE_TYPE } from '../../constants/categoryManagement/HomepageCategorySettings';
import { getLanguageNameFromCode } from '../../utils/langUtils';
export const GET_AVAILABLE_LANGUAGES = registerQuery({
  fieldName: 'languages',
  fetcher() {
    return http.get('cos-domains/v1/domain-setup-tasks/supported-languages').then(response => response.objects.map(({
      tag
    }) => ({
      value: tag,
      text: getLanguageNameFromCode(tag)
    })));
  }
});
export const KNOWLEDGE_BASES_QUERY = registerQuery({
  fieldName: 'knowledgeBases',
  fetcher() {
    return KnowledgeBaseApi.get();
  }
});
export const KNOWLEDGE_BASES_THEME_QUERY = registerQuery({
  fieldName: 'themeType',
  args: ['themeSettingsId'],
  fetcher({
    themeSettingsId: __themeSettingsId
  }) {
    return TEMPLATE_TYPE.CONTENT;
    // return KnowledgeBaseApi.getKnowledgeBaseTheme(themeSettingsId).then(
    //   data => {
    //     return data.values.group_layout.layout_type;
    //   }
    // );
  }
});
export const useFetchKnowledgeBases = ({
  includeVariants = false
} = {
  includeVariants: false
}) => {
  const _useQuery = useQuery(KNOWLEDGE_BASES_QUERY),
    {
      data
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  const {
    hasGate
  } = useHasGate(GATES.KNOWLEDGE_BASE_V3_1);
  if (!hasGate) {
    return Object.assign({
      data: data ? data.knowledgeBases.objects : undefined
    }, rest);
  }
  const {
    new: newKBs,
    legacy,
    migrated
  } = knowledgeBaseMigrationReportSync();
  return {
    loading: false,
    error: null,
    data: [...newKBs.map(({
      knowledgeBase
    }) => convertSCPToLegacyKnowledgeBase(knowledgeBase)), ...(includeVariants ? newKBs.reduce((acc, {
      knowledgeBase: {
        translations
      }
    }) => [...acc, ...Object.values(translations || {}).map(convertSCPToLegacyKnowledgeBase)], []) : []), ...legacy.map(({
      knowledgeBase
    }) => knowledgeBase), ...migrated.map(({
      scpKnowledgeBase
    }) => convertSCPToLegacyKnowledgeBase(scpKnowledgeBase))],
    refetch: refetchCache
  };
};
export const useFetchKnowledgeBase = knowledgeBaseId => {
  const _useFetchKnowledgeBas = useFetchKnowledgeBases(),
    {
      data
    } = _useFetchKnowledgeBas,
    rest = _objectWithoutPropertiesLoose(_useFetchKnowledgeBas, _excluded2);
  return Object.assign({
    data: data && knowledgeBaseId ? data.find(({
      id
    }) => id === knowledgeBaseId) : undefined
  }, rest);
};